<template>
    <div class="form-group bs-form-group">
        <label :for="name" class="text-uppercase mb-0">{{ label }}</label>
        <input :type="type || 'text'" class="form-control shadow-sm border-top-0 border-left-0 border-bottom-1"
               :id="name" v-model="inputValue"
               :min="min"
        >
        <small class="form-text text-danger" v-if="error && error[name]">{{ error[name][0] }}</small>
        <small class="form-text text-muted" v-else-if="help">{{ help }}</small>
    </div>
</template>

<script>
export default {
  name: 'InputField',
  props: ['type', 'label', 'name', 'help', 'value', 'error', 'min'],
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss">
    .bs-form-group {
        > label {
            font-size: 0.75rem;
            font-weight: 600;
        }
    }
</style>
